import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Icons from "../../../../../Config/Images";
import "./Header.css";
import { useDispatch } from "react-redux";
import { getLoggedInUserDetailsAPI } from "../../../../../Store/Action/UserAction";

const HeaderBlack = ({ noLoginBtn }) => {

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  // const isWelcomePage = location?.pathname == "/";

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [userOnboardingStatus, setUserOnboardingStatus] = useState("");

  const [showLogginBtn, setShowLogginBtn] = useState(false);

  const [hasSubscription, setHasSubscription] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  // Functions to handle navigation
  const handleNavigate = (path) => {
    navigate(path, { state: { notLoggedIn: true } });
  };

  useEffect(() => {
    // setShowLogginBtn(true);
  }, [location?.state]);

  useEffect(() => {
    dispatch(
      getLoggedInUserDetailsAPI({}, (result) => {
        setHasSubscription(result?.data?.[0]?.user_subscription?.length > 0);
       
        if (result?.data?.[0]?.user_status_name?.toLowerCase() === "approved") {
          setShowLogginBtn(false);
        } else {
          setShowLogginBtn(true);
        }
        if (result?.status) {
          setUserOnboardingStatus(
            result?.data?.[0]?.user_status_name?.toLowerCase()
          );
        }
      })
    );
  }, [dispatch]);

  return (
    <>
      <div className="section-1-header">
        <div className="left-side-header-div">
          <div
            className="logo-name"
            style={{ cursor: "pointer" }}
            onClick={() => {
              userOnboardingStatus === "approved" && hasSubscription
                ? handleNavigate("/home")
                : handleNavigate("/");
            }}

            // add partner route with conditional rendering (userStatus === "approved")
          >
            {/* ZABALI */}
            <img src={Icons.zabali_header_logo_icon} alt="" />
          </div>
          <div className="header-menus">
            <ul className={`header-menus-ul ${isMenuOpen ? "active" : ""}`}>
              <li onClick={() => handleNavigate("/about-us")}>About Us</li>
              <li onClick={() => handleNavigate("/contact-us")}>Contact Us</li>
              {/* <li onClick={() => handleNavigate("/subscriptionPlan")}>
                {" "}
                Pricing
              </li> */}
              <li onClick={() => handleNavigate("/inquiry-form")}>Inquiry</li>

              {/* <li onClick={() => handleNavigate("/")}>Partners</li> */}
            </ul>
          </div>
        </div>

        {!noLoginBtn && showLogginBtn && (
          <>
            <div className="header-right-side">
              <button
                className="book-demo-btn"
                onClick={() => handleNavigate("/login")}
              >
                Login
              </button>
            </div>
          </>
        )}

        <div className="hamburger-icon" onClick={toggleMenu}>
          <img
            src={isMenuOpen ? Icons.close_ham_img : Icons.ham_menu_img}
            alt={isMenuOpen ? "close menu" : "hamburger menu"}
          />
        </div>
      </div>
    </>
  );
};

export default HeaderBlack;
